import { render, staticRenderFns } from "./back-menu.vue?vue&type=template&id=3b7dff57&scoped=true"
import script from "./back-menu.vue?vue&type=script&lang=js"
export * from "./back-menu.vue?vue&type=script&lang=js"
import style0 from "./back-menu.vue?vue&type=style&index=0&id=3b7dff57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7dff57",
  null
  
)

export default component.exports